import localStorage from './local-storage';

export function imageBlur() {
  return !localStorage.getItem('token');
}

// const MAPTILER_API_KEY = 'IOrAk6DZGyIWzSQnCOjm';
// const GOOGLE_API_KEY = 'AIzaSyDFyIyTgHO-6t8-G00VMCbt9Q4XbaHZhIc';
// const GOOGLE_API_KEY = 'AIzaSyD66ge8is_TWmUcuttAhvDU9Rj5vac2MaQ'; // legacy account

export function imageUrl(hash) {
  // if (localStorage.getItem('token')) {
  //   return `//static.boligninja.dk/cim/${hash}.jpg`;
  // }
  return `https://static.boligninja.dk/cim/${hash}.jpg`;
}

export function staticMap(
  lat,
  lon,
  zoom = '14' /*street, city, zip, country = 'DK'*/
) {
  const scale = __CLIENT__ ? (window.devicePixelRatio > 1.5 ? 2 : 1) : 1;
  // const dest = `${street},+${zip}+${city},+${country},+Europa`;
  // return `https://maps.googleapis.com/maps/api/staticmap?language=da&center=${dest}&size=205x163&scale=${scale}&key=${GOOGLE_API_KEY}`;

  // const scale = (__CLIENT__ && window.devicePixelRatio > 1.5 && '@2x') || '';
  const width = '205';
  const height = '163';

  const dest = `${String(lat).substr(0, 7)},${String(lon).substr(0, 7)}`;

  return `https://www.boligninja.dk/staticmap?language=da&center=${dest}&size=${width}x${height}&scale=${scale}&zoom=${zoom}`;

  // return `https://maps.tilehosting.com/styles/streets/static/${String(
  //   lon
  // ).substr(0, 7)},${String(lat).substr(
  //   0,
  //   7
  // )},${zoom}/${width}x${height}${scale}.png?key=${MAPTILER_API_KEY}`;
}
